import React, { useState } from "react";
import OfferCard from "./offerCard";

const OfferPage = () => {
  const offers = [
    {
      _id: "691c0632d0e5d9000ec75b26",
      disburse_report_tags: [],
      is_clicked: null,
      is_deleted: false,
      credit_limit: "5 Lakhs",
      emi: "36062",
      tenure: "15",
      status: "true",
      customer_id: "9861670786",
      raw_response:
        '{"code":"200","msg":"Success","model":{"activeLoan":"no","availLoan":false,"consents":1,"dob":"yes","email":"yes","empInfoCooldown":"","gender":"yes","higherLimitConsent":null,"isAttributable":"","isCibilAvailable":"no","isDedupe":"no","isDevicedataAvailable":"no","isIncomeMandatory":"no","isIncomeVerified":"no","isKycRequired":"yes","isNachRequired":"no","isPanImageRequired":"yes","isReferenceRequired":"yes","isSAEnabled":1,"isSelfieRequired":"yes","leadStatus":"Approved","mobile":"yes","noAttributionReason":"","productId":"","redirectReason":null,"redirectToKB":false,"rejectReasonMsg":"","state":"eligible","substate":"na","vkycRequired":false}}',
      app_url: "https://dgtm.co/?5abbVjdY",
      lead_id: "691c05b12b664a000ea03b12",
      lender_name: "KreditBee",
      lender_id: "662752eb65fdba1a48d6e466",
      logo_image_url: "https://campaigns.digitmoney.in/image/KreditBee.png",
      priority: 2,
      pancard: "AURPB6839K",
      contact_phone: "9861670786",
      created_at: "2025-11-18T05:37:54.227Z",
      updated_at: "2025-11-18T05:37:54.227Z",
      apr: "29-50%",
      kfs_doc: "https://lender-kfs.s3.ap-south-1.amazonaws.com/kreditbee.pdf",
      penal_charges: "4%",
      processing_fee: "5.10%",
      interest_rate: "12-28.5%",
    },
    {
      _id: "691c0631d0e5d9000ec75b1e",
      disburse_report_tags: [],
      is_clicked: null,
      is_deleted: false,
      credit_limit: "5K to 2Lakhs",
      emi: "19380",
      tenure: "12",
      status: "true",
      customer_id: "9861670786",
      app_url: "https://dgtm.co/?VLGPLf60",
      raw_response: '{"result":"SUCCESS"}',
      lead_id: "691c05b12b664a000ea03b12",
      lender_name: "TrueBalance",
      lender_id: "662752eb65fdba1a48d6e474",
      logo_image_url: "https://campaigns.digitmoney.in/image/TrueBalance.png",
      priority: 3,
      pancard: "AURPB6839K",
      contact_phone: "9861670786",
      created_at: "2025-11-18T05:37:53.397Z",
      updated_at: "2025-11-18T05:37:53.397Z",
      apr: "48.6%-90%",
      kfs_doc: "https://lender-kfs.s3.ap-south-1.amazonaws.com/truebalance.pdf",
      penal_charges: "5%",
      processing_fee: "8.90%",
      interest_rate: "Starting 2.4%/month",
    },
    {
      _id: "691c0631d0e5d9000ec75b0f",
      disburse_report_tags: [],
      is_clicked: null,
      is_deleted: false,
      credit_limit: "5 Lakhs",
      emi: "25448",
      tenure: "24",
      status: "true",
      app_url: "https://dgtm.co/?j2BmfJ3z",
      customer_id: "691c05b12b664a000ea03b12",
      raw_response: "Success",
      lead_id: "691c05b12b664a000ea03b12",
      lender_name: "Hero Fincorp",
      lender_id: "67ef646df80610d286084e60",
      logo_image_url: "https://campaigns.digitmoney.in/image/herofincorp.png",
      priority: 4,
      pancard: "AURPB6839K",
      contact_phone: "9861670786",
      created_at: "2025-11-18T05:37:53.090Z",
      updated_at: "2025-11-18T05:37:53.090Z",
      apr: "27.77%",
      kfs_doc:
        "https://lender-kfs.s3.ap-south-1.amazonaws.com/hero-fincorp.pdf",
      penal_charges: "3% on overdue",
      processing_fee: "3%",
      interest_rate: "19-30% ",
    },
    {
      _id: "691c06312b664a000ea03bf1",
      disburse_report_tags: [],
      is_clicked: null,
      is_deleted: false,
      credit_limit: "3k to 2 Lakhs",
      emi: "93054",
      tenure: "2.5",
      status: "true",
      app_url: "https://dgtm.co/?p3x2RDQx",
      customer_id: "9861670786",
      raw_response:
        '{"message":"Lead generated successfully","leadId":"EY8H8DS","utmLink":"https://www.creditsea.com/onboarding/sign-up/enter-mobile?source=28710364"}',
      lead_id: "691c05b12b664a000ea03b12",
      lender_name: "Creditsea",
      lender_id: "68b7cb3721c19b150d2893da",
      logo_image_url:
        "https://campaigns.digitmoney.in/image/partners/creditsea.png",
      priority: 5,
      pancard: "AURPB6839K",
      contact_phone: "9861670786",
      created_at: "2025-11-18T05:37:53.291Z",
      updated_at: "2025-11-18T05:37:53.291Z",
      apr: "16%- 32.5%",
      kfs_doc: "https://lender-kfs.s3.ap-south-1.amazonaws.com/creditsea.pdf",
      penal_charges: "3% on overdue",
      processing_fee: "4%",
      interest_rate: "14-36%",
    },
    {
      _id: "691c0631d0e5d9000ec75b15",
      disburse_report_tags: [],
      is_clicked: null,
      is_deleted: false,
      credit_limit: "5 Lakhs",
      emi: "9985",
      tenure: "24",
      status: "true",
      app_url: "https://dgtm.co/?E611lzns",
      customer_id: "1670786",
      raw_response: "Success",
      lead_id: "691c05b12b664a000ea03b12",
      lender_name: "Kissht",
      lender_id: "666ec1953a9a969d8f9980f1",
      logo_image_url: "https://campaigns.digitmoney.in/image/kissht.png",
      priority: 7,
      pancard: "AURPB6839K",
      contact_phone: "9861670786",
      created_at: "2025-11-18T05:37:53.103Z",
      updated_at: "2025-11-18T05:37:53.103Z",
      apr: "35%",
      kfs_doc: "https://lender-kfs.s3.ap-south-1.amazonaws.com/kissht.pdf",
      penal_charges: "0.2% per day",
      processing_fee: "7%",
      interest_rate: "14-36%",
    },
    {
      _id: "691c06312b664a000ea03be9",
      disburse_report_tags: [],
      is_clicked: null,
      is_deleted: false,
      credit_limit: "10 Lakhs",
      emi: "13247",
      tenure: "60",
      status: "true",
      app_url: "https://dgtm.co/?zUshWANr",
      customer_id: "691c05b12b664a000ea03b1270786",
      raw_response: "Success",
      lead_id: "691c05b12b664a000ea03b12",
      lender_name: "Poonawalla",
      lender_id: "6799b8fada60414f0f195bf9",
      logo_image_url: "https://campaigns.digitmoney.in/image/poonawalla.png",
      priority: 10,
      pancard: "AURPB6839K",
      contact_phone: "9861670786",
      created_at: "2025-11-18T05:37:53.019Z",
      updated_at: "2025-11-18T05:37:53.019Z",
      apr: "",
      kfs_doc: "https://lender-kfs.s3.ap-south-1.amazonaws.com/poonawalla.pdf",
      penal_charges: "2% on overdue",
      processing_fee: "4%",
      interest_rate: "Starting 9.99%",
    },
    {
      _id: "691c0639d0e5d9000ec75b30",
      disburse_report_tags: [],
      is_clicked: null,
      is_deleted: false,
      credit_limit: "5 Lakhs",
      emi: "18582",
      tenure: "36",
      status: "true",
      app_url: "https://dgtm.co/?N0e0wJ0y",
      customer_id: "9861670786",
      raw_response:
        '{"is_success":true,"data":[{"loan_consent_id":"823f857d-2a69-42db-a2a0-5e1edf160ed3","consent_version":1},{"loan_consent_id":"5f4ed91c-b9b7-47cf-b68a-a6ec3099b0a0","consent_version":1}]}',
      lead_id: "691c05b12b664a000ea03b12",
      lender_name: "UnityBank",
      lender_id: "67762d497ae263a3ec86347e",
      logo_image_url: "https://campaigns.digitmoney.in/image/unity.png",
      pancard: "AURPB6839K",
      contact_phone: "9861670786",
      created_at: "2025-11-18T05:38:01.287Z",
      updated_at: "2025-11-18T05:38:01.287Z",
      apr: "21.75% - 34.5%",
      kfs_doc: "https://lender-kfs.s3.ap-south-1.amazonaws.com/unitybank.pdf",
      penal_charges: "2.5% on overdue",
      processing_fee: "3%",
      interest_rate: "16-30%",
    },
  ];

  const [expandedId, setExpandedId] = useState(null);

  const handleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const handleGetOffer = (offer) => {
    console.log("Get Offer Clicked:", offer);
    // integrate HDM push or redirect logic here
  };

  return (
    <div className=" w-full max-w-[400px] mx-auto min-h-screen bg-[#004739] text-white  flex flex-col items-center">
      {/* Header */}
      <div className="w-full max-w-md text-center px-2 pt-4 pb-5 rounded-b-[50px] bg-white">
        <div className="flex justify-between w-full items-center mb-8">
          <img
            src="/assets/img/Footer logo.png"
            alt="digitmoney logo"
            className="h-[17px] w-[100px]"
          />
          <img
            src="/assets/img/dmiicon.png"
            alt="DMI Finance logo"
            className="h-[32px] w-[123px]"
          />
        </div>

        <div className=" text-black  rounded-xl mt-6">
          <img
            src="/assets/img/Layer_1 (46).png"
            className="w-[117px] h-[117px] mx-auto object-cover"
            alt="snail"
          />
          <p className="mt-4 text-[14px] leading-[18px] font-atkinson">
            We regret to inform you that your application <br /> with{" "}
            <span className="font-atkinson-bold">DMI Finance</span> cannot be
            processed. You <br /> may explore other eligible offers
          </p>
        </div>
      </div>

      {/* Title */}
      <h2 className="text-[35px] text-[#12F280] font-bomstad-bold mt-10">
        Don't Worry!!
      </h2>
      <p className="text-[18px] leading-[20px] tracking-wider  my-3 font-bomstad-thin text-center">
        We've Found Alternative Offers <br /> That Fit Your Profile
      </p>

      {/* Offer List */}
      <div className="w-full max-w-md space-y-4 mt-2 px-4">
        {offers.map((offer) => (
          <OfferCard
            key={offer._id}
            offer={offer}
            isExpanded={expandedId === offer._id}
            onExpand={() => handleExpand(offer._id)}
            handleClick={() => handleGetOffer(offer)}
          />
        ))}
      </div>

      {/* Footer Note */}
      <div className="px-5 py-4 gap-3 flex flex-col ">
        <p className="text-center font-bomstad-bold  text-[15px] leading-[1] text-[#00B894] ">
          Choose from these incredible offers that best suit your needs
        </p>
        <p className="text-xs opacity-60 text-center max-w-md mt-6">
          *These pre-approved offers are subject to change at discretion of Bank
          / NBFC after receiving all your documents and details. Final offer
          will be based on risk policy of Bank / NBFC. We do not guarantee that
          final offer will be same as Pre-approved offer.
        </p>
      </div>
    </div>
  );
};

export default OfferPage;
